// Trajetos.jsx - Route History Screen
// (Complete file - Version: 2025-04-15b)

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import L from 'leaflet';
// import ReactDOMServer from 'react-dom/server'; // Usually not needed for simple icons
import { MapContainer, TileLayer, Marker, Popup, Tooltip, useMap, Polyline } from 'react-leaflet';
import { FaCar, FaSearch, FaMapMarkerAlt, FaListAlt, FaKey, FaSlash, FaCalendarAlt, FaClock, FaRoute, FaRedo, FaLayerGroup, FaExpandArrowsAlt } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

// Import Geosearch (ensure package is installed: npm install leaflet-geosearch)
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';

import 'leaflet/dist/leaflet.css';

// --- Constants ---
const markerIconColor = '#A71C1C'; // Color for info panel icon, etc.
const routeColor = '#A71C1C'; // Color for the route polyline
const componentStyleId = 'trajetos-styles-v7'; // Unique ID for this screen's styles

// --- CSS to be Injected ---
// (Includes global box-sizing, start/end markers, map controls, geosearch, date picker, VEHICLE CARD STYLES, scrollbar)
const injectedCss = `
  /* --- Global Box Sizing --- */
  *, *::before, *::after {
    box-sizing: border-box;
  }

  /* Styles for start/end markers */
  .route-start-icon div, .route-end-icon div {
    background-color: white; border: 2px solid green; border-radius: 50%;
    width: 15px; height: 15px; margin-left: -7.5px; margin-top: -7.5px;
    text-align: center; line-height: 11px; font-weight: bold; font-size: 10px; color: green;
  }
  .route-end-icon div { border-color: red; color: red; }

  /* Styles for map controls */
   .custom-map-controls-trajetos {
    position: absolute; top: 80px; /* Adjust as needed */ right: 10px; z-index: 1000;
    display: flex; flex-direction: column; gap: 5px;
  }
   .custom-map-button-trajetos {
    background-color: white; color: #333; border: 1px solid #ccc;
    border-radius: 4px; padding: 5px; cursor: pointer; box-shadow: 0 1px 5px rgba(0,0,0,0.4);
    display: flex; align-items: center; justify-content: center; width: 30px; height: 30px;
  }
   .custom-map-button-trajetos:hover { background-color: #f4f4f4; }
   .custom-map-button-trajetos svg { font-size: 14px; }

  /* Geosearch input override */
  .leaflet-control-geosearch.bar,
  .leaflet-control-geosearch.bar form {
    border: 1px solid #ccc !important; box-shadow: 0 1px 5px rgba(0,0,0,0.2) !important;
    border-radius: 4px !important; height: 34px !important; display: flex !important;
    align-items: center !important; margin: 10px !important; background-color: white; z-index: 1001; /* Ensure it's above map */
  }
   .leaflet-control-geosearch.bar form input.search {
      height: 100% !important; border: none !important; padding-left: 34px !important;
      font-size: 13px !important; outline: none; width: 180px; /* Adjust width */
   }
   .leaflet-control-geosearch.bar form input.search::placeholder { color: #999; opacity: 1; }
   .leaflet-control-geosearch.bar .glass {
     position: absolute; left: 10px !important; top: 50% !important; transform: translateY(-50%) !important;
     width: 16px !important; height: 16px !important; border: none !important;
     background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="%23A71C1C"><path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/></svg>') !important;
     background-size: contain !important; background-repeat: no-repeat !important; background-position: center !important;
   }
   .leaflet-control-geosearch.bar a.reset { right: 10px !important; top: 50% !important; transform: translateY(-50%) !important; }
   /* Results list */
   .leaflet-control-geosearch .results {
        border-radius: 4px; border: 1px solid #ccc; box-shadow: 0 1px 5px rgba(0,0,0,0.2);
        margin: 0 10px; max-height: 200px; overflow-y: auto; z-index: 1001; /* Above map */
        background-color: white;
    }
    .leaflet-control-geosearch .results > * { padding: 8px 10px; font-size: 13px; border-bottom: 1px solid #eee; cursor: pointer; }
    .leaflet-control-geosearch .results > :last-child { border-bottom: none; }
    .leaflet-control-geosearch .results > .active,
    .leaflet-control-geosearch .results > :hover { background-color: #f4f4f4; }

  /* Map panel sizing */
   .map-panel .leaflet-container { height: 100% !important; width: 100%; }

  /* Date picker input */
   .date-picker-input {
       padding: 6px 10px !important; border: 1px solid #ced4da !important;
       border-radius: 4px !important; font-size: 13px !important;
       height: 34px !important; width: 150px !important; box-sizing: border-box !important;
       transition: border-color 0.2s ease; color: #495057;
   }
   .date-picker-input:hover { border-color: #adb5bd !important; }
   .date-picker-input:focus {
       border-color: #80bdff !important; outline: 0 !important;
       box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
   }
   .react-datepicker-wrapper { display: inline-block; vertical-align: middle; }

  /* Vehicle Button Icon styles */
  .vehicle-button-icon {
      font-size: 24px; margin-bottom: 4px;
      color: #0d6efd; /* Default icon color */
      transition: color 0.2s ease;
  }
  .vehicle-button-selected .vehicle-button-icon { color: #ffffff; /* White icon for selected */ }

  /* Remove border from the last vehicle button */
  .vehicle-selector > button:last-child { border-right: none !important; }

  /* Optional: Style scrollbar for Webkit browsers */
   .vehicle-selector::-webkit-scrollbar { height: 6px; }
   .vehicle-selector::-webkit-scrollbar-track { background-color: #e9ecef; }
   .vehicle-selector::-webkit-scrollbar-thumb { background-color: #adb5bd; border-radius: 3px; }
   .vehicle-selector::-webkit-scrollbar-thumb:hover { background-color: #6c757d; }
`;

// --- Helper Components ---
function LeafletGeoSearch() {
    const map = useMap();
    useEffect(() => {
        const provider = new OpenStreetMapProvider({ params: { 'accept-language': 'pt', countrycodes: 'br' } });
        const searchControl = new GeoSearchControl({
            provider: provider, style: 'bar', showMarker: true, showPopup: false,
            marker: { icon: new L.Icon.Default(), draggable: false, },
            resultFormat: ({ result }) => result.label, maxMarkers: 1, retainZoomLevel: false,
            animateZoom: true, autoClose: true, searchLabel: 'Digite um endereço...', keepResult: true, updateMap: true,
        });
        map.addControl(searchControl);
        return () => { map.removeControl(searchControl); };
    }, [map]);
    return null;
}

function MapController({ bounds, center, zoom }) {
    const map = useMap();
    useEffect(() => {
        if (bounds && bounds.isValid()) {
            map.flyToBounds(bounds, { padding: [30, 30], animate: true, duration: 1.0 });
        } else if (center) {
            map.flyTo(center, zoom || map.getZoom(), { animate: true, duration: 1.0 });
        }
    }, [bounds, center, zoom, map]);
    // Invalidate map size slightly after initial load or potential resize
    useEffect(() => {
        const timer = setTimeout(() => {
            if (map) {
                map.invalidateSize();
            }
        } , 100); // Short delay ensures container has settled
        return () => clearTimeout(timer);
    }, [map]); // Re-run if map instance changes
    return null;
}

// --- Main Component ---
export default function Trajetos() {
    // State Variables
    const [vehicles, setVehicles] = useState([]);
    const [selectedVehicleId, setSelectedVehicleId] = useState(null);
    const [startDate, setStartDate] = useState(() => new Date(2025, 3, 14, 4, 7, 0)); // Example Date: April 14, 2025 04:07
    const [endDate, setEndDate] = useState(() => new Date(2025, 3, 15, 4, 7, 0)); // Example Date: April 15, 2025 04:07
    const [routeData, setRouteData] = useState([]);
    const [routeInfo, setRouteInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [mapBounds, setMapBounds] = useState(null);
    const [vehicleFilter, setVehicleFilter] = useState(''); // State for filter
    const mapRef = useRef();
    const navigate = useNavigate();

    // --- Effects ---
    // Inject CSS
    useEffect(() => {
        const styleElement = document.createElement('style'); styleElement.id = componentStyleId;
        styleElement.innerHTML = injectedCss; document.head.appendChild(styleElement);
        return () => { const el = document.getElementById(componentStyleId); if (el) el.remove(); };
    }, []);
    // Fetch initial list of vehicles
    useEffect(() => {
        const fetchVehicleList = async () => {
            try {
                // *** Replace with your actual API endpoint ***
                const token = localStorage.getItem("token"); // Recupera o token do localStorage
                const response = await axios.get('https://sis.itraker.com.br/api/associacaoapp', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const dados = response.data.dados || [];
                const vehicleList = dados.map(item => ({ id: item.idProdutos, placa: item.placa_produto || 'N/P' }));
                setVehicles(vehicleList);
            } catch (err) { console.error("Error fetching vehicle list:", err); setError("Erro ao carregar lista."); }
        };
        fetchVehicleList();
    }, []);

    // Fetch route data
    const fetchRoute = async (vehicleIdToFetch = null) => {
        const targetVehicleId = vehicleIdToFetch || selectedVehicleId;
        if (!targetVehicleId) { setError("Selecione um veículo."); return; }
        if (!startDate || !endDate) { setError("Selecione o período."); return; }
        if (endDate < startDate) { setError("Data final inválida."); return; }
        setLoading(true); setError(null); setRouteData([]); setRouteInfo(null); setMapBounds(null);
        try {
            // *** Replace with your ACTUAL HISTORY API endpoint ***
            console.log(`Workspaceing route for ${targetVehicleId} from ${startDate.toISOString()} to ${endDate.toISOString()}`);
            // Example: const response = await axios.get(`/api/history?vehicleId=${targetVehicleId}&startTime=${startDate.toISOString()}&endTime=${endDate.toISOString()}`);
            // const historyData = response.data;

            // *** SIMULATED RESPONSE (Remove/Replace) ***
            await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate delay
            let points = []; let currentLat = -10.1845; let currentLng = -48.3336; let currentTime = startDate.getTime(); points.push({ lat: currentLat, lng: currentLng, timestamp: currentTime, speed: 0, ign: false }); for (let i = 0; i < 20; i++) { currentLat += (Math.random() - 0.5) * 0.005; currentLng += (Math.random() - 0.5) * 0.005; currentTime += (Math.random() * 5 + 1) * 60000; if (currentTime > endDate.getTime()) break; points.push({ lat: currentLat, lng: currentLng, timestamp: currentTime, speed: Math.random() * 60, ign: Math.random() > 0.2 }); } if(points[points.length-1].timestamp < endDate.getTime()){ points.push({ lat: currentLat - 0.001, lng: currentLng - 0.001, timestamp: endDate.getTime() - 10000, speed: Math.random() * 20, ign: true }); } const simulatedPoints = points; const simulatedInfo = { odometer: Math.random()*100 + 1200, hourmeter: Math.random()*10 + 50, maxSpeed: 60 + Math.random()*20, stops: Math.floor(Math.random()*5), driver: "Sem motorista", startTime: startDate.toISOString(), endTime: endDate.toISOString() }; const historyData = { points: simulatedPoints, info: simulatedInfo };
            // *** End Simulation ***

            if (historyData && historyData.points && historyData.points.length > 0) {
                const positions = historyData.points.map(p => [p.lat, p.lng]);
                setRouteData(positions); setRouteInfo(historyData.info || {});
                if (positions.length > 0) { const bounds = L.latLngBounds(positions); setMapBounds(bounds); }
            } else { setRouteData([]); setRouteInfo(null); setError("Nenhum dado de trajeto encontrado."); }
        } catch (err) { console.error("Error fetching route:", err); setError("Erro ao buscar trajeto."); setRouteData([]); setRouteInfo(null); }
        finally { setLoading(false); }
    };

    // --- Render Logic ---
    const startPoint = routeData.length > 0 ? routeData[0] : null;
    const endPoint = routeData.length > 0 ? routeData[routeData.length - 1] : null;
    const startIcon = L.divIcon({ className: 'route-start-icon', html: '<div>S</div>', iconSize: [15, 15], iconAnchor: [7.5, 7.5] });
    const endIcon = L.divIcon({ className: 'route-end-icon', html: '<div>F</div>', iconSize: [15, 15], iconAnchor: [7.5, 7.5] });
    const initialCenter = [-10.1845, -48.3336]; // Palmas, TO - Brazil

    const filteredVehicles = vehicles.filter(v =>
        v.placa.toLowerCase().includes(vehicleFilter.toLowerCase())
    );

    return (
        // Use updated pageContainer style to fit within parent
        <div style={styles.pageContainer}>
            {/* --- Top Bar (Dates above Vehicles) --- */}
            <div style={styles.topBar}>
                {/* Date Picker Row */}
                <div style={styles.datePickerContainer}>
                    <FaCalendarAlt style={styles.dateIcon} />
                    <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} selectsStart startDate={startDate} endDate={endDate} showTimeSelect timeFormat="HH:mm" timeIntervals={15} dateFormat="dd/MM/yyyy HH:mm" className="date-picker-input" popperPlacement="bottom-start" />
                    <span style={{ margin: '0 5px', color: '#6c757d' }}>-</span>
                    <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} selectsEnd startDate={startDate} endDate={endDate} minDate={startDate} showTimeSelect timeFormat="HH:mm" timeIntervals={15} dateFormat="dd/MM/yyyy HH:mm" className="date-picker-input" popperPlacement="bottom-start" />
                </div>

                {/* Filter Row */}
                <div style={styles.filterContainer}>
                    <input type="text" style={styles.vehicleFilterInput} placeholder="Filtrar por placa..." value={vehicleFilter} onChange={(e) => setVehicleFilter(e.target.value)} />
                </div>

                {/* Vehicle Selector Row */}
                <div style={styles.vehicleSelector} className="vehicle-selector">
                    {filteredVehicles.map(v => (
                        <button key={v.id} onClick={() => { setSelectedVehicleId(v.id); fetchRoute(v.id); }} style={{ ...styles.vehicleButton, ...(v.id === selectedVehicleId ? styles.vehicleButtonSelected : {}) }} className={v.id === selectedVehicleId ? 'vehicle-button-selected' : ''} title={`Ver trajeto de ${v.placa}`} >
                            <FaCar className="vehicle-button-icon" />
                            {v.placa}
                        </button>
                    ))}
                    {filteredVehicles.length === 0 && vehicleFilter && ( <span style={{ padding: '10px', fontStyle: 'italic', color: '#6c757d', alignSelf: 'center', marginLeft: '10px' }}>Nenhuma placa encontrada.</span> )}
                </div>
            </div>

            {error && <div style={styles.errorBar}>{error}</div>}
            {loading && <div style={{textAlign: 'center', padding: '5px', backgroundColor: '#fff3cd', borderBottom: '1px solid #ffeeba', color: '#856404', fontSize: '13px'}}>Carregando trajeto...</div>}


            {/* --- Main Content (Map + Info Panel) --- */}
            <div style={styles.mainContent}>
                {/* Left Panel: Map */}
                <div style={styles.mapPanel} className="map-panel">
                    <MapContainer center={initialCenter} zoom={13} scrollWheelZoom={true} style={{ height: '100%', width: '100%' }} ref={mapRef}>
                        <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                        <MapController bounds={mapBounds} center={mapBounds ? null : initialCenter} zoom={mapBounds ? null : 13} />
                        <LeafletGeoSearch />
                        {routeData.length > 0 && (<Polyline positions={routeData} color={routeColor} weight={4} opacity={0.8} />)}
                        {startPoint && (<Marker position={startPoint} icon={startIcon}><Popup>Início: {startDate.toLocaleString()}</Popup></Marker>)}
                        {endPoint && (<Marker position={endPoint} icon={endIcon}><Popup>Fim: {endDate.toLocaleString()}</Popup></Marker>)}
                    </MapContainer>
                    <div className="custom-map-controls-trajetos">
                        <button className="custom-map-button-trajetos" title="Atualizar Rota" onClick={()=>fetchRoute()} disabled={loading || !selectedVehicleId}><FaRedo /></button>
                        <button className="custom-map-button-trajetos" title="Camadas"><FaLayerGroup /></button>
                        <button className="custom-map-button-trajetos" title="Ajustar Zoom à Rota" onClick={() => mapBounds && setMapBounds(mapBounds)} disabled={!mapBounds}><FaExpandArrowsAlt /></button>
                    </div>
                </div>

                {/* Right Panel: Information */}
                <div style={styles.infoPanel} className="info-panel">
                    {selectedVehicleId && !loading && routeInfo ? (
                        <div style={styles.infoContent}>
                            <div style={styles.infoVehicle}><FaCar size={30} color={markerIconColor}/><span style={{fontWeight: 'bold', fontSize: '16px'}}>{vehicles.find(v => v.id === selectedVehicleId)?.placa || 'N/P'}</span></div>
                            <h4 style={{marginTop: 0, marginBottom: '15px', borderBottom: '1px solid #ddd', paddingBottom: '5px'}}>Detalhes do Período</h4>
                            {routeInfo.startTime ? (
                                <>
                                    <p style={styles.infoContentP}><strong>Início:</strong> {new Date(routeInfo.startTime).toLocaleString()}</p>
                                    <p style={styles.infoContentP}><strong>Fim:</strong> {new Date(routeInfo.endTime).toLocaleString()}</p>
                                    <p style={styles.infoContentP}><strong>Hodômetro:</strong> {routeInfo.odometer?.toFixed(1) ?? '-'} km</p>
                                    <p style={styles.infoContentP}><strong>Horímetro:</strong> {routeInfo.hourmeter?.toFixed(1) ?? '-'} h</p>
                                    <p style={styles.infoContentP}><strong>Velocidade Máx.:</strong> {routeInfo.maxSpeed?.toFixed(0) ?? '-'} km/h</p>
                                    <p style={styles.infoContentP}><strong>Paradas:</strong> {routeInfo.stops ?? '0'}</p>
                                    <p style={styles.infoContentP}><strong>Motorista:</strong> {routeInfo.driver || '-'}</p>
                                </>
                            ) : (<p style={styles.infoContentP}>Nenhum detalhe disponível para este trajeto.</p>)}
                        </div>
                    ) : selectedVehicleId && loading ? (
                        <div style={styles.infoPlaceholder}>Carregando trajeto...</div>
                    ) : (
                        <div style={styles.infoPlaceholder}>Selecione um veículo para ver o trajeto.</div>
                    )}
                </div>
            </div>
        </div>
    );
}

// --- Component Styles ---
const styles = {
    // UPDATED pageContainer style to fit parent, not viewport
    pageContainer: {
        display: 'flex', flexDirection: 'column',
        height: '100%', width: '100%', // Fill parent container
        backgroundColor: '#f0f2f5', fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        overflow: 'hidden', // Prevent page scrollbars
    },
    // UPDATED topBar style for column layout
    topBar: {
        display: 'flex', flexDirection: 'column', gap: '8px', padding: '10px 15px',
        backgroundColor: '#ffffff', borderBottom: '1px solid #dee2e6', flexShrink: 0,
    },
    datePickerContainer: { display: 'flex', alignItems: 'center', gap: '8px', width: '100%', justifyContent: 'flex-start', },
    dateIcon: { color: '#6c757d', fontSize: '18px', flexShrink: 0 },
    // Filter row styles
    filterContainer: { display: 'flex', alignItems: 'center', paddingBottom: '8px', width: '100%', },
    // Filter input styles
    vehicleFilterInput: { padding: '6px 10px', border: '1px solid #ced4da', borderRadius: '4px', fontSize: '13px', height: '34px', flexGrow: 1, marginRight: '10px', boxSizing: 'border-box', color: '#495057', },
    // Vehicle selector row styles (scrollable)
    vehicleSelector: {
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden',
        padding: '4px 0',
        gap: '0px',
        backgroundColor: '#e9ecef',
        height: '70px',
        width: '100%',
        alignItems: 'stretch',
        scrollbarWidth: 'thin',
        scrollbarColor: '#adb5bd #e9ecef',
        borderRadius: '4px',
        flexWrap: 'nowrap',            // impede quebra de linha
        whiteSpace: 'nowrap',          // impede quebra de texto
    },
    // Vehicle button styles (vertical card)
    vehicleButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        minWidth: '90px',
        maxWidth: '90px',
        height: '100%',
        padding: '5px',
        border: 'none',
        borderRight: '1px solid #ced4da',
        backgroundColor: 'transparent',
        color: '#6f42c1',
        cursor: 'pointer',
        textAlign: 'center',
        fontSize: '11px',
        fontWeight: '500',
        transition: 'background-color 0.2s ease',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    // Selected vehicle button styles
    vehicleButtonSelected: {
        backgroundColor: '#dc3545', // Selected background color
        color: '#ffffff', // Selected text color
        fontWeight: 'bold',
    },
    errorBar: { padding: '10px 15px', backgroundColor: '#f8d7da', color: '#721c24', borderBottom: '1px solid #f5c6cb', textAlign: 'center', fontSize: '14px', flexShrink: 0 },
    // Main content area styles (flex, overflow hidden)
    mainContent: {
        flexGrow: 1, display: 'flex', overflow: 'hidden',
    },
    // Map panel styles (flex item, relative position, minWidth 0)
    mapPanel: {
        flex: 3, position: 'relative', borderRight: '1px solid #dee2e6',
        minWidth: 0, display: 'flex', flexDirection: 'column',
    },
    // Info panel styles (flex item, scroll, minWidth 0)
    infoPanel: {
        flex: 1, padding: '15px', backgroundColor: '#f8f9fa',
        overflowY: 'auto', minWidth: 0,
    },
    infoContent: { fontSize: '14px', color: '#333', },
    infoContentP: { margin: '0 0 8px 0', lineHeight: '1.4'},
    infoVehicle: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid #eee'},
    infoPlaceholder: { textAlign: 'center', color: '#6c757d', marginTop: '30px', fontStyle: 'italic', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' },
    centeredMessage: { display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1, fontSize: '16px', color: '#555', textAlign: 'center', padding: '30px' },
    errorMessage: { /* Potentially redundant style */ },
};
// Base style for other icons (not heavily used here)
const iconStyle = { fontSize: '18px', color: markerIconColor };

// Optional: Register pt-BR locale for DatePicker
/* ... */